import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';
import { useDialog, useSearch, useRequestState } from '@app/hooks';
import { AddClient } from './add-client';
import { useTable } from '@app/components/table';
import { ClientList } from './client-list';
import { getClients } from '../slice';
import { selectClientState } from '../selector';
import { useAuthRolePermissions } from '@app/utils';

export const ClientListPage = () => {
  const addClientDialog = useDialog();
  const tableProps = useTable();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getClients());
  }, [dispatch]);

  const { data, loading } = useRequestState({
    stateSelector: selectClientState,
    errorShown: true,
  });

  const searchProps = useSearch({
    data,
    fields: ['firstName', 'lastName', 'email', 'phone', 'id'],
  });
  const { hasPermission } = useAuthRolePermissions();
  const canAddClient = hasPermission('Client', 'w');

  return (
    <>
      <Header
        title={Strings.clients.clients}
        helperText={''}
        actionButtonTitle={canAddClient ? Strings.clients.addClient : undefined}
        onClickActionButton={addClientDialog.show}
        searchBarProps={{
          placeholder: Strings.common.search,
          onChange: searchProps.handleSearchChange,
        }}
      />
      <ClientList
        tableProps={tableProps}
        rows={searchProps.filteredRows}
        loading={loading}
        canAddClient={canAddClient}
      />

      {addClientDialog.visible && <AddClient open onClose={addClientDialog.hide} />}
    </>
  );
};
